import { Callout } from "@/src/components/design-system/Callout/Callout";
import { DismissController } from "@/src/components/DismissController";
import { Bot } from "lucide-react";

const DOCS_HREF =
  "https://langfuse.com/docs/api-and-data-platform/features/agent-skill";

/**
 * Informational, dismissible banner that highlights Langfuse's support for AI
 * coding agents via the Agent Skill, MCP server, and CLI. Rendered on the
 * organization overview page.
 */
export function AgentToolsBanner() {
  return (
    <DismissController id="agent-tools-banner:v1" family="callouts">
      {({ onDismiss }) => (
        <div className="mb-4">
          <Callout
            variant="info"
            align="middle"
            actions={[{ type: "link", label: "Learn more", href: DOCS_HREF }]}
            onDismiss={onDismiss}
          >
            <div className="flex items-start gap-2 sm:items-center">
              <Bot className="icon-base mt-0.5 shrink-0 sm:mt-0" />
              <span>
                <span className="font-bold">
                  Langfuse works great with your AI coding agents.
                </span>{" "}
                Connect Claude Code, Codex, and other agents to your data with
                the Langfuse Agent Skill, MCP server, and CLI.
              </span>
            </div>
          </Callout>
        </div>
      )}
    </DismissController>
  );
}
